import React, { lazy, Suspense, useState } from "react";
import "./products.css";
import OurUniquness from "./OurUniquness";

const HowWineMade = lazy(() => import("./howWineMade"));
const OurUniqunessVm = lazy(() => import("./OurUniquness_VM"));
const HowWineMadeVm = lazy(() => import("./howWineMade_VM"));

function Products() {
  const [selectedProduct, setSelectedProduct] = useState("mompoWine");
  function selectedProdyct(selectedIteam) {
    if (selectedProduct == "mompoWine") {
      if (selectedIteam == "mompoWine") {
        setSelectedProduct("mompoWine");
      } else {
        setSelectedProduct("mompoWine2");
      }
    } else {
      if (selectedIteam == "mompoWine") {
        setSelectedProduct("mompoWine");
      } else {
        setSelectedProduct("mompoWine2");
      }
    }
  }
  return (
    <>
      {/* <motion.div
        className="productlist-continer"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <div className="products-headding">
          <motion.h2
            whileInView="visible"
            viewport={{ once: false }}
            transition={{ duration: 0.8 }}
            variants={{
              visible: { y: 0, opacity: 1 },
              hidden: { y: 50, opacity: 0 },
            }}
          >
            Product Range
          </motion.h2>
          <motion.h4
            whileInView="visible"
            viewport={{ once: false }}
            transition={{ duration: 0.8, delay: 0.3 }}
            variants={{
              visible: { y: 0, opacity: 1 },
              hidden: { y: 50, opacity: 0 },
            }}
          >
            Our All Products
          </motion.h4>
        </div>
        <div className="productlist-main-box">
          <motion.div
            className={`productlist-products ${
              selectedProduct == "mompoWine" ? "selected" : ""
            }`}
            onClick={() => selectedProdyct("mompoWine")}
            whileInView="visible"
            viewport={{ once: false }}
            transition={{ duration: 0.8, delay: 0.5 }}
            variants={{
              visible: { y: 0, opacity: 1 },
              hidden: { y: 50, opacity: 0 },
            }}
          >
            <div className="productlist-products-inner">
              <div className="productlist-products-inner-img">
                <img
                  src={mompoBottole}
                  alt="holly wine and mompo mass wine bottle image"
                />
                <div className="productlist-products-inner-img-shadow"></div>
              </div>
              <div className="productlist-products-inner-discription">
                <h4>Mompo Wine</h4>
                <p>Holy wine named MOMPO wine</p>
              </div>
              <div className="productlist-products-back"></div>
            </div>
          </motion.div>
          <motion.div
            className={`productlist-products ${
              selectedProduct == "mompoWine2" ? "selected" : ""
            }`}
            onClick={() => selectedProdyct("mompoWine2")}
            whileInView="visible"
            viewport={{ once: false }}
            transition={{ duration: 0.8, delay: 0.7 }}
            variants={{
              visible: { y: 0, opacity: 1 },
              hidden: { y: 50, opacity: 0 },
            }}
          >
            <div className="productlist-products-inner">
              <div className="productlist-products-inner-img">
                <img src={vinumMissaeBottole} alt="holly wine bottle image" />
                <div className="productlist-products-inner-img-shadow"></div>
              </div>
              <div className="productlist-products-inner-discription">
                <h4>Vinum Missae</h4>
                <p>Holy wine named Vinum Missae</p>
              </div>
              <div className="productlist-products-back"></div>
            </div>
          </motion.div>
        </div>
      </motion.div> */}
      {selectedProduct == "mompoWine" ? (
        <>
          <OurUniquness />
          <Suspense fallback={null}>
            <HowWineMade />
          </Suspense>
        </>
      ) : (
        <Suspense fallback={null}>
          <OurUniqunessVm />
          <HowWineMadeVm />
        </Suspense>
      )}
    </>
  );
}

export default Products;
